import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { cn } from '@/utils/cn-tw-merge';

interface SearchSectionSubtitleProps extends React.HTMLAttributes<HTMLParagraphElement> {
  hasTelemedicine?: boolean;
  noServiceType?: boolean;
}

export const SearchSectionSubtitle = ({ className, hasTelemedicine = false, noServiceType = false, ...props }: SearchSectionSubtitleProps) => {
  const serviceTypeText = hasTelemedicine ? 'Agendamento de teleconsultas' : 'Agendamento de consultas e exames';

  return (
    <>
      { noServiceType
        ? (
            <Typography variant={TypographyVariant.BODY_STRONG} className={cn('text-white whitespace-pre-line md:whitespace-normal', className)} {...props}>
              Ainda não temos atendimento na sua cidade, mas queremos te avisar quando chegar
            </Typography>
          )
        : (
            <Typography variant={TypographyVariant.BODY_STRONG} className={cn('text-white whitespace-pre-line md:whitespace-normal', className)} {...props}>
              {serviceTypeText}
              {' '}
              com valores reduzidos,
              {' '}
              <span className="text-success-300">
                sem mensalidades.
              </span>
            </Typography>
          )}
    </>
  );
};
